export function sleep(timeoutMs) {
    return new Promise(resolve => setTimeout(resolve, timeoutMs));
}
//# sourceMappingURL=sleep.js.map